import Vue from 'vue'
import SocialSharing from 'vue-social-sharing'

Vue.use(SocialSharing)
